export const getEventClub = (event) => {
  if (!event) return null;

  if (event.club && typeof event.club === "object") {
    return event.club;
  }

  if (event.clubId && typeof event.clubId === "object") {
    return event.clubId;
  }

  return null;
};
